import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const About: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="about">
      <div className="about-content">
        <div className="about-text">
          <h2>{t('about.title')}</h2>
          <h3>{t('about.subtitle')}</h3>
          <p>{t('about.paragraph1')}</p>
          <p>{t('about.paragraph2')}</p>
        </div>
        <div className="about-image">
          {/* Replace with actual image */}
          <div style={{ 
            width: '100%', 
            height: '400px', 
            background: '#d4a574', 
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#FFFFFF',
            fontSize: '1.5rem'
          }}>
            [Personal Training Image]
          </div>
        </div>
      </div>
      <div className="about-stats">
        <div className="stat-item">
          <div className="stat-number">500+</div>
          <div className="stat-label">{t('about.stats.clients')}</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">10+</div>
          <div className="stat-label">{t('about.stats.experience')}</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">95%</div>
          <div className="stat-label">{t('about.stats.satisfaction')}</div>
        </div>
      </div>
    </section>
  );
};

export default About; 